import { get } from 'lodash'
import { useSelector } from './p2p-connect'

export default function getGriffinMetadata() {
  const store = require('../stores/configureStore').default
  const { server: { griffinMetadata = {} } = {} } = store.getState()

  return griffinMetadata
}

/**
 * Hook to obtain griffin metadata from the redux store
 */
export function useGriffinMetadata() {
  const griffinMetadata = useSelector(state =>
    get(state, 'server.griffinMetadata', {})
  )
  return griffinMetadata
}
